import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';
import DatePicker from '../../../components/DatePicker/index';
import MySelect from '../../../../../components/MySelect';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';

export class SpecifiedItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regexNumber = /^(0*[1-9]\d*(\.\d{0,2})?|0+\.\d*[1-9]\d*)$/; // regex to check for number > 0
    let value = target.type === 'checkbox' ? target.checked : target.value;
    if (regexNumber.test(value)) {
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    } else {
      value = '';
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    }
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.fromWhom = '';
    item.howMuch = '';
    item.currencyExpensesClaimed = '';
    item.dateReimbursementReceived = '';
    this.change(item);
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  handleSelectDepreciationType = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
    } = this.props;
    return (
      <div className="expenses">
        <div className="row">
          <div className="form-group col-sm-1 col-md-1">
            <div className="row">
              <div className={'col-sm-12 form-group radio'} style={{ paddingTop: '35px' }}>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      type="radio"
                      value="true"
                      name="selected"
                      checked={item.isSelected === 'true'}
                      onChange={this.onChange('isSelected')}
                    />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
          </div>
          <div className="form-group col-sm-11 col-md-11">
            <div className="row">
              <div className="form-group col-sm-4 col-md-4">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.itemType}
                  fieldName={messages.itemType}
                >
                  <Textbox
                    disabled={disabled}
                    name="itemType"
                    type="text"
                    onChange={this.onChange('itemType')}
                    value={item.itemType}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.itemType}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-sm-4 col-md-4">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.descriptionOfValuables}
                  fieldName={messages.descriptionOfValuables}
                >
                  <Textbox
                    disabled={disabled}
                    name="descriptionOfValuables"
                    type="text"
                    onChange={this.onChange('descriptionOfValuables')}
                    value={item.descriptionOfValuables}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.descriptionOfValuables}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-sm-4 col-md-4">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.amountAUD}
                  fieldName={messages.amountAUD}
                >
                  <Textbox
                    disabled={disabled}
                    name="amountAUD"
                    type="text"
                    onChange={this.onChange('amountAUD')}
                    value={item.amountAUD}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.amountAUD}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>    
        </div>
      </div>
    );
  }
}

SpecifiedItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/components/SpecifiedItem/SpecifiedItem.js